import React, { FC } from 'react';
import { translate, translationKeys } from 'logic/translations/translations.service';
import { PrimaryButton } from 'components/buttons/primary-button/primary.button';
import { useDispatch } from 'react-redux';
import { requestTutoringSlice } from 'logic/store/request-tutoring/request-tutoring.slice';

type Props = {
  disabled?: boolean;
};

export const NextStepButton: FC<Props> = ({ disabled }) => {
  const dispatch = useDispatch();
  const onClick = () => dispatch(requestTutoringSlice.actions.moveToNextTutoringRequestFlowStep());

  return (
    <PrimaryButton onClick={onClick} disabled={disabled}>
      {translate(translationKeys.buttons.next)}
    </PrimaryButton>
  );
};
